import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Container, Form, Row, Col, Card, Button } from 'react-bootstrap';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight, FaSearch, FaRedo } from 'react-icons/fa';

import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';

import '../components/cssfile/mcq.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const McqPractice = () => {
  const [addcategory, setAddcategory] = useState([]);
  const [subcategory, setsubcategory] = useState([]);
  const [section, setsection] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const sliderRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [categoryResponse, subcategoryResponse, sectionResponse] =
          await Promise.all([
            axios.get(apiUrl + 'serverside/mcq_practice.php'),
            axios.get(apiUrl + 'serverside/mcq_practice_sub.php'),
            axios.get(apiUrl + 'serverside/mcq_practice_section.php')
          ]);

        setAddcategory(categoryResponse.data || []);
        setsubcategory(subcategoryResponse.data || []);
        setsection(sectionResponse.data || []);
      } catch (error) {
        console.error('Error fetching MCQ practice data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  /*
   * ORIGINAL FILTER LOGIC PRESERVED
   */
  const filteredSeries = addcategory.filter(
    item =>
      item.status == 1 &&
      item.topic_name
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) &&
      (!selectedCategory || item.a_id === selectedCategory)
  );

  const createSlug = value =>
    value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const sliderSettings = {
    dots: false,
    infinite: addcategory.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: addcategory.length > 1,
    autoplaySpeed: 3500,
    arrows: false,
    adaptiveHeight: true
  };

  const handleCategorySelect = categoryId => {
    setSelectedCategory(categoryId);
  };

  const handleReset = () => {
    setSelectedCategory(null);
  };

  if (loading) {
    return (
      <div className="mcq-page">
        <Header />

        <div className="mcq-loading">
          <div className="mcq-loading-spinner" />
          <h5>Loading MCQ Practice</h5>
          <p>Please wait while we prepare your practice library.</p>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div className="mcq-page">
      <Header />

      {/* ================= HERO ================= */}
      <section className="mcq-hero">
        <div className="mcq-hero-overlay">
          <Container>
            <div className="mcq-hero-content">
              <span className="mcq-hero-label">
                MCQ PRACTICE
              </span>

              <h1>
                Practice Smarter.
                <br />
                <span>Improve Every Day.</span>
              </h1>

              <p>
                Select an exam topic, choose a chapter and start
                practicing multiple-choice questions.
              </p>
            </div>
          </Container>
        </div>
      </section>

      {/* ================= MAIN CONTENT ================= */}
      <Container className="mcq-container">

        {/* PAGE HEADER */}
        <div className="mcq-page-header">
          <div>
            <span className="mcq-section-label">
              PRACTICE LIBRARY
            </span>

            <h2>
              MCQ Practice Questions
            </h2>

            <p>
              Explore exam topics and practice chapter-wise questions.
            </p>
          </div>

          <div className="mcq-total-count">
            <strong>{filteredSeries.length}</strong>
            <span>Topics</span>
          </div>
        </div>

        {/* SEARCH */}
        <div className="mcq-search-wrapper">
          <FaSearch className="mcq-search-icon" />

          <Form.Control
            type="text"
            placeholder="Search exam topics..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="mcq-search-input"
          />

          {searchTerm && (
            <button
              type="button"
              className="mcq-search-clear"
              onClick={() => setSearchTerm('')}
            >
              ×
            </button>
          )}
        </div>

        <Row className="mcq-layout">

          {/* ================= CATEGORY SIDEBAR ================= */}
          <Col lg={3} md={4} className="mcq-sidebar-column">

            <div className="mcq-sidebar">

              <div className="mcq-sidebar-header">
                <div>
                  <span>
                    EXAM TOPICS
                  </span>

                  <h4>
                    Choose Topic
                  </h4>
                </div>

                <span className="mcq-sidebar-count">
                  {addcategory.length}
                </span>
              </div>

              <div className="mcq-category-slider">

                {addcategory.length > 0 ? (
                  <Slider
                    ref={sliderRef}
                    {...sliderSettings}
                  >
                    {addcategory.map(category => {
                      const active =
                        selectedCategory === category.a_id;

                      return (
                        <div
                          key={category.a_id}
                          className="mcq-category-slide"
                        >
                          <button
                            type="button"
                            className={`mcq-category-button ${
                              active ? 'active' : ''
                            }`}
                            onClick={() =>
                              handleCategorySelect(category.a_id)
                            }
                          >

                            <div className="mcq-category-image">
                              <img
                                src={category.image}
                                alt={category.topic_name}
                              />
                            </div>

                            <div className="mcq-category-info">
                              <span>
                                EXAM TOPIC
                              </span>

                              <strong>
                                {category.topic_name}
                              </strong>
                            </div>

                            <div className="mcq-category-arrow">
                              →
                            </div>

                          </button>
                        </div>
                      );
                    })}
                  </Slider>
                ) : (
                  <div className="mcq-sidebar-empty">
                    No exam topics available.
                  </div>
                )}

              </div>

              {/* SLIDER CONTROLS */}
              {addcategory.length > 1 && (
                <div className="mcq-slider-controls">

                  <button
                    type="button"
                    onClick={() =>
                      sliderRef.current &&
                      sliderRef.current.slickPrev()
                    }
                    aria-label="Previous topic"
                  >
                    <FaChevronLeft />
                  </button>

                  <span>
                    Browse Topics
                  </span>

                  <button
                    type="button"
                    onClick={() =>
                      sliderRef.current &&
                      sliderRef.current.slickNext()
                    }
                    aria-label="Next topic"
                  >
                    <FaChevronRight />
                  </button>

                </div>
              )}

              {/* RESET */}
              <Button
                type="button"
                className="mcq-reset-button"
                onClick={handleReset}
              >
                <FaRedo />
                Reset Filter
              </Button>

            </div>

          </Col>

          {/* ================= CONTENT ================= */}
          <Col lg={9} md={8} className="mcq-content-column">

            {selectedCategory && (
              <div className="mcq-active-filter">

                <div>
                  <span>
                    FILTERED BY
                  </span>

                  <strong>
                    {addcategory.find(
                      item => item.a_id === selectedCategory
                    )?.topic_name}
                  </strong>
                </div>

                <button
                  type="button"
                  onClick={handleReset}
                >
                  Clear ×
                </button>

              </div>
            )}

            {filteredSeries.length > 0 ? (

              <div className="mcq-series-list">

                {filteredSeries.map(categoryItem => {

                  const categorySubcategories =
                    subcategory.filter(
                      subItem =>
                        subItem.a_id == categoryItem.a_id
                    );

                  return (
                    <Card
                      key={categoryItem.a_id}
                      className="mcq-series-card"
                    >

                      {/* CATEGORY HEADER */}
                      <div className="mcq-series-header">

                        <div className="mcq-series-image">
                          <img
                            src={categoryItem.image}
                            alt={categoryItem.topic_name}
                          />
                        </div>

                        <div className="mcq-series-title">
                          <span>
                            TEST SERIES
                          </span>

                          <h3>
                            {categoryItem.topic_name}
                          </h3>

                          <p>
                            Select a chapter below to begin
                            your MCQ practice.
                          </p>
                        </div>

                      </div>

                      {/* SUBCATEGORIES */}
                      <Card.Body className="mcq-series-body">

                        {categorySubcategories.length > 0 ? (

                          categorySubcategories.map(subItem => {

                            const sectionItems =
                              section.filter(
                                sectionItem =>
                                  sectionItem.id === subItem.id
                              );

                            return (
                              <div
                                key={subItem.id}
                                className="mcq-subcategory"
                              >

                                <div className="mcq-subcategory-header">

                                  <div>
                                    <span>
                                      SECTION
                                    </span>

                                    <h4>
                                      {subItem.topic_name}
                                    </h4>
                                  </div>

                                  <span className="mcq-subcategory-count">
                                    {sectionItems.length}
                                  </span>

                                </div>

                                {/* SECTIONS */}
                                <div className="mcq-section-list">

                                  {sectionItems.length > 0 ? (

                                    sectionItems.map(
                                      (sectionItem, index) => {

                                        const slug =
                                          createSlug(
                                            sectionItem.section_name
                                          );

                                        return (
                                          <Link
                                            key={
                                              sectionItem.sec_id
                                            }
                                            to={{
                                              pathname:
                                                `/mcq/${slug}`,
                                              state: {
                                                sec_id:
                                                  sectionItem.sec_id,
                                                id:
                                                  subItem.id,
                                                topic_name:
                                                  subItem.topic_name
                                              }
                                            }}
                                            className="mcq-section-item"
                                          >

                                            <div className="mcq-chapter-number">
                                              <span>
                                                CH
                                              </span>

                                              <strong>
                                                {String(
                                                  index + 1
                                                ).padStart(
                                                  2,
                                                  '0'
                                                )}
                                              </strong>
                                            </div>

                                            <div className="mcq-section-name">
                                              <strong>
                                                {
                                                  sectionItem.section_name
                                                }
                                              </strong>

                                              <span>
                                                Practice MCQs
                                              </span>
                                            </div>

                                            <div className="mcq-question-count">
                                              <strong>
                                                {
                                                  sectionItem.total_question
                                                }
                                              </strong>

                                              <span>
                                                Questions
                                              </span>
                                            </div>

                                            <div className="mcq-section-arrow">
                                              <FaChevronRight />
                                            </div>

                                          </Link>
                                        );
                                      }
                                    )

                                  ) : (

                                    <div className="mcq-no-sections">
                                      No chapters available.
                                    </div>

                                  )}

                                </div>

                              </div>
                            );
                          })

                        ) : (

                          <div className="mcq-no-sections">
                            No sections available for this
                            test series.
                          </div>

                        )}

                      </Card.Body>

                    </Card>
                  );
                })}

              </div>

            ) : (

              <div className="mcq-empty-state">

                <div className="mcq-empty-icon">
                  <FaSearch />
                </div>

                <h3>
                  No Test Series Found
                </h3>

                <p>
                  We couldn't find a matching exam topic.
                  Try another search or reset the filter.
                </p>

                <Button
                  type="button"
                  onClick={() => {
                    setSearchTerm('');
                    setSelectedCategory(null);
                  }}
                >
                  Reset Search
                </Button>

              </div>

            )}

          </Col>

        </Row>

      </Container>

      <Footer />
    </div>
  );
};

export default McqPractice;